/** @module Sourcing/SampleRightWidget */
define([
    "dojo/_base/declare",
    "dijit/_WidgetBase",
    "dijit/_TemplatedMixin",
    "dojo/text!./SampleRightWidget.html"
], function(declare,_WidgetBase,_TemplatedMixin,template) {

	return declare([_WidgetBase, _TemplatedMixin], {
        templateString: template,

        numSuppliers: 0,
        numFactories: 0,
        numColorways: 0,
        numColoredMaterials: 0,
        numSizes: 0,
        numSamples: 0,

        _setNumSuppliersAttr: {node: "suppliersNode", type: "innerText"},
        _setNumFactoriesAttr: {node: "factoriesNode", type: "innerText"},
        _setNumColorwaysAttr: {node: "colorwaysNode", type: "innerText"},
        _setNumColoredMaterialsAttr: {node: "coloredMaterialsNode", type: "innerText"},
        _setNumSizesAttr: {node: "sizesNode", type: "innerText"},
        _setNumSamplesAttr: {node: "samplesNode", type: "innerText"}
	});
});
